import { axiosInstance } from "api/axios-config/axios-config";
import { GetExportExcelPapersGoodsIssue } from "api/models/request/paper-inventory/paper-inventory";
import {
  IAddPaperGoodsReceipt,
  IUpdatePaperGoodsReceipt,
} from "mobx-stores/_models/paper-inventory/paper-goods-receipt/paper-goods-receipt";
import { IPaperGoodsReceiptItemProperties } from "mobx-stores/_models/paper-inventory/paper-goods-receipt/paper-goods-receipt-item";
import { BaseBussiness } from "../base";

class PaperGoodsIssueBusiness extends BaseBussiness<
  IPaperGoodsReceiptItemProperties,
  IAddPaperGoodsReceipt,
  IUpdatePaperGoodsReceipt,
  IPaperGoodsReceiptItemProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }

  public exportExcel = async (req: GetExportExcelPapersGoodsIssue) => {
    try {
      var res = await axiosInstance.get(this.url + "/export-excel", {
        params: req,
        responseType: "blob",
      });

      return res.data as Blob;
    } catch (error) {
      console.error("Fail exportExcel", error);
      return Promise.reject(error);
    }
  };
}

export const paperGoodsIssueBusiness = new PaperGoodsIssueBusiness(
  "/api/app/paper-goods-issue",
);
